import { MenuItem } from '@mui/material';

import { GDMMenuItemComponent } from './GDMMenuItem.type';

/* TODO: Implement component using GDM default design */
const GDMMenuItem: GDMMenuItemComponent = props => <MenuItem {...props} />;

export default GDMMenuItem;
